export default __webpack_public_path__ + "static/media/iPhoneCrop.d2dfff0a.png";